import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=d5808648&scoped=true"
import script from "./RemindPassword.js?vue&type=script&lang=js&external"
export * from "./RemindPassword.js?vue&type=script&lang=js&external"
import style0 from "./RemindPassword.scss?vue&type=style&index=0&id=d5808648&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5808648",
  null
  
)

export default component.exports